<template>
  <div class="companyInfo_cla">
    <comPanyInfo></comPanyInfo>
  </div>
</template>
<script>
import comPanyInfo from '../../comComponent/comPanyInfo'
// import { mapActions } from 'vuex'
export default {
  data () {
    return {}
  },
  mounted () {

  },
  beforeDestroy () {
    let role = sessionStorage.getItem('role') === '"superadministrator"' || sessionStorage.getItem('role') === '"operator"'
    if (role) {
      // this.setAppKey('')
      this.$root.appKey = 'all'
    }
  },
  // methods: {
  //   ...mapActions(['setAppKey'])
  // },
  components: {
    comPanyInfo: comPanyInfo
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/enterpriseSetting/companyInfo.vue